import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

import Popup from '../../UI/Popup/Popup';
import {isHR} from '../../../utils/isHr';

import './LegalGuaranteeLink.scss';

const LEGAL_GUARANTEE_IMAGE = 'https://s3.emmezeta.hr/media/legal_guarantee_notice_HR.png';

// Legal guarantee notice is required for the Croatian store only and is shown for every product.
const LegalGuaranteeLink = ({className}) => {
    const {t} = useTranslation();
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    if (!isHR) {
        return null;
    }

    const label = t('legal_guarantee');

    return (
        <>
            <span
                className={['legal-guarantee-link', className].filter(Boolean).join(' ')}
                onClick={() => setIsPopupOpen(true)}
            >
                {label}
            </span>
            <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} title={label}>
                <img className="legal-guarantee-link__image" src={LEGAL_GUARANTEE_IMAGE} alt={label}/>
            </Popup>
        </>
    );
};

export default LegalGuaranteeLink;
